module.exports = __webpack_public_path__ + "static/media/IMG_1835.2d99cb0c.JPG";